const initialState = {
    order_details_id: JSON.parse(localStorage.getItem('order_details_id')) || null,
};

const orderDetailsIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_ORDER_DETAILS_ID':
            return {
                ...state,
                order_details_id: action.payload,
            };
        default:
            return state;
    }
};

export default orderDetailsIdReducer;